module.exports = __webpack_public_path__ + "media/src/assets/images/admin-6b538fb7d72e6f10cbd38e8c7494306b.png";